import {DataStatus, getTimeFromDate} from 'platform/components';

import {
  useGetTireSetRequestQuery,
  usePatchTireSetRequestMutation,
  usePostTireSetCancelRequestMutation,
  usePostTireSetRequestMutation,
} from '@dms/api/core';

import {parseDate, TestIdProps} from 'shared/web';

import {handleApiError} from '../../../utils/handleApiError';
import {RequestTireSetData, RequestTireSetForm} from './RequestTireSetForm';

interface RequestTireSetProps extends TestIdProps {
  tireSetId: string;
  tireOrderId: string;
  onSave?: VoidFunction;
  onClose: VoidFunction;
}

export function RequestTireSet(props: RequestTireSetProps) {
  const {data, isLoading, isError} = useGetTireSetRequestQuery({
    orderId: props.tireOrderId,
    setId: props.tireSetId,
  });

  const [postTireSetRequest] = usePostTireSetRequestMutation();
  const [patchTireSetRequest] = usePatchTireSetRequestMutation();
  const [postTireSetCancelRequest] = usePostTireSetCancelRequestMutation();

  const handleSubmit = async (formData: RequestTireSetData) => {
    const requestData = {
      orderId: props.tireOrderId,
      setId: props.tireSetId,
      body: {...formData, destinationBranchId: formData?.requestBranchId},
    };

    await (data ? patchTireSetRequest(requestData) : postTireSetRequest(requestData))
      .unwrap()
      .then(() => props.onClose())
      .then(() => props.onSave?.())
      .catch(handleApiError);
  };

  const handleCancelRequest = () =>
    postTireSetCancelRequest({orderId: props.tireOrderId, setId: props.tireSetId})
      .unwrap()
      .then(() => props.onClose())
      .then(() => props.onSave?.())
      .catch(handleApiError);

  return (
    <DataStatus isLoading={isLoading} isError={isError}>
      <RequestTireSetForm
        tireOrderId={props.tireOrderId}
        tireSetId={props.tireSetId}
        defaultValues={{
          requestBranchId: data?.destinationBranchId,
          note: data?.note,
          neededAtTime: data?.neededAt ? getTimeFromDate(parseDate(data.neededAt)) : '07:00',
          neededAtDate: parseDate(data?.neededAt) ?? undefined,
        }}
        onSubmit={handleSubmit}
        onClose={props.onClose}
        onCancelRequest={data ? handleCancelRequest : undefined}
      />
    </DataStatus>
  );
}
